import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Button, Descriptions, message, Divider } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import api from '../utils/api';

function Profile() {
  const [user, setUser] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    const stored = localStorage.getItem('user');
    if (stored) setUser(JSON.parse(stored));
    loadUserInfo();
  }, []);

  const loadUserInfo = async () => {
    try {
      const res = await api.get('/auth/me');
      if (res.code === 200) {
        setUser(res.data);
      }
    } catch (err) {}
  };

  const handleChangePassword = async () => {
    try {
      const values = await form.validateFields();
      if (values.newPassword !== values.confirmPassword) {
        message.error('两次输入的密码不一致');
        return;
      }
      const res = await api.put('/auth/password', {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword
      });
      if (res.code === 200) {
        message.success('密码修改成功');
        form.resetFields();
      }
    } catch (err) {}
  };

  return (
    <div>
      <h3>个人设置</h3>

      <Card title="基本信息" style={{ marginTop: 16 }}>
        <Descriptions column={2}>
          <Descriptions.Item label="用户名">{user?.username}</Descriptions.Item>
          <Descriptions.Item label="显示名称">{user?.name}</Descriptions.Item>
          <Descriptions.Item label="角色">{user?.role === 'admin' ? '管理员' : '主体'}</Descriptions.Item>
          {user?.supplier_name && (
            <Descriptions.Item label="所属主体">{user.supplier_name}</Descriptions.Item>
          )}
        </Descriptions>
      </Card>

      <Card title="修改密码" style={{ marginTop: 16 }}>
        <Form form={form} layout="vertical" style={{ maxWidth: 400 }}>
          <Form.Item name="oldPassword" label="原密码" rules={[{ required: true, message: '请输入原密码' }]}>
            <Input.Password prefix={<LockOutlined />} />
          </Form.Item>
          <Form.Item name="newPassword" label="新密码" rules={[{ required: true, message: '请输入新密码' }, { min: 6, message: '密码至少6位' }]}>
            <Input.Password prefix={<LockOutlined />} />
          </Form.Item>
          <Form.Item name="confirmPassword" label="确认新密码" rules={[{ required: true, message: '请确认新密码' }]}>
            <Input.Password prefix={<LockOutlined />} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={handleChangePassword}>修改密码</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default Profile;
